<script setup lang="ts">
import { WrapperGeneralInfo } from '@shared/ui/wrappers'

defineOptions({
  name: 'LessonFormLayout',
})
</script>

<template>
  <WrapperGeneralInfo class="lesson-form-layout">
    <template #info>
      <slot name="main" />
    </template>
    <template #additional>
      <slot name="aside" />
    </template>
  </WrapperGeneralInfo>
</template>

<style scoped lang="scss" src="./LessonFormLayout.scss" />
